import React from 'react';

const F = "'Inter', system-ui, sans-serif";

export default function UeberUns({ heading, text }) {
  return (
    <section style={styles.section}>
      <div style={styles.inner}>
        <div style={styles.textSide}>
          <span style={styles.eyebrow}>Unser Platz</span>
          <h2 style={styles.heading}>{heading}</h2>
          <div style={styles.divider} />
          <p style={styles.text}>{text}</p>
        </div>
        <div style={styles.iconSide}>
          <div style={styles.iconBox}>
            <span style={styles.bigIcon}>🏕️</span>
            <div style={styles.iconStat}><strong>Idyllische Ruhe</strong></div>
          </div>
          <div style={styles.iconBox}>
            <span style={styles.bigIcon}>🌄</span>
            <div style={styles.iconStat}><strong>Traumhafte</strong><span>Naturlage</span></div>
          </div>
          <div style={styles.iconBox}>
            <span style={styles.bigIcon}>❤️</span>
            <div style={styles.iconStat}><strong>Herzliche</strong><span>Gastgeber</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: { backgroundColor: 'white', padding: '5.5rem 1.5rem' },
  inner: { maxWidth: '1100px', margin: '0 auto', display: 'flex', gap: '4rem', alignItems: 'center', flexWrap: 'wrap' },
  textSide: { flex: '1 1 340px' },
  eyebrow: { fontSize: '0.75rem', fontFamily: F, fontWeight: '600', letterSpacing: '1.8px', textTransform: 'uppercase', color: '#1e8449' },
  heading: { color: '#0f172a', fontFamily: F, fontSize: 'clamp(1.7rem,4vw,2.4rem)', fontWeight: '800', marginTop: '0.5rem', marginBottom: '1rem', lineHeight: '1.15', letterSpacing: '-0.5px' },
  divider: { width: '36px', height: '3px', borderRadius: '2px', background: 'linear-gradient(90deg, #1e8449, #4ade80)', marginBottom: '1.2rem' },
  text: { color: '#64748b', fontFamily: F, fontSize: '1rem', lineHeight: '1.8', whiteSpace: 'pre-wrap' },
  iconSide: { flex: '1 1 280px', display: 'flex', flexDirection: 'column', gap: '0.75rem' },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '1.1rem 1.25rem',
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
  },
  bigIcon: { fontSize: '1.8rem', flexShrink: 0 },
  iconStat: { display: 'flex', flexDirection: 'column', fontFamily: F, color: '#0f172a', fontSize: '0.9rem' },
};
